import { capitalize, isString } from '../../../lodash';
import { logger } from '../../../logger';
export class MainHandler {
    constructor(config) {
        this.config = config;
    }
    static log(opts) {
        const prefix = '[Autocomplete]';
        if (opts.event === 'destroy') {
            logger.log(`${prefix} Destroy`);
            return;
        }
        const { action, item } = opts;
        const msg = [
            prefix,
            capitalize(opts.event),
            `Trigger="${action.trigger}"`,
            `Filter=${action.filter !== undefined ? `"${action.filter}"` : 'None'}`,
            `Type=${action.type ? `"${action.type.name}"` : 'None'}`,
            `Handler=${item ? `"${item.trigger.name}"` : 'None'}`,
        ].join(' ');
        logger.log(msg);
    }
    onOpen(action) {
        var _a, _b, _c;
        const item = this.getItem(action);
        MainHandler.log({ event: 'open', action, item });
        return (_c = (_b = item === null || item === void 0 ? void 0 : (_a = item.handler).onOpen) === null || _b === void 0 ? void 0 : _b.call(_a, action)) !== null && _c !== void 0 ? _c : false;
    }
    onClose(action) {
        var _a, _b, _c;
        const item = this.getItem(action);
        MainHandler.log({ event: 'close', action, item });
        return (_c = (_b = item === null || item === void 0 ? void 0 : (_a = item.handler).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, action)) !== null && _c !== void 0 ? _c : false;
    }
    onArrow(action) {
        var _a, _b, _c;
        const item = this.getItem(action);
        MainHandler.log({ event: 'arrow', action, item });
        return (_c = (_b = item === null || item === void 0 ? void 0 : (_a = item.handler).onArrow) === null || _b === void 0 ? void 0 : _b.call(_a, action)) !== null && _c !== void 0 ? _c : false;
    }
    onEnter(action) {
        var _a, _b, _c;
        const item = this.getItem(action);
        MainHandler.log({ event: 'enter', action, item });
        return (_c = (_b = item === null || item === void 0 ? void 0 : (_a = item.handler).onEnter) === null || _b === void 0 ? void 0 : _b.call(_a, action)) !== null && _c !== void 0 ? _c : false;
    }
    onFilter(action) {
        var _a, _b, _c;
        const item = this.getItem(action);
        MainHandler.log({ event: 'filter', action, item });
        return (_c = (_b = item === null || item === void 0 ? void 0 : (_a = item.handler).onFilter) === null || _b === void 0 ? void 0 : _b.call(_a, action)) !== null && _c !== void 0 ? _c : false;
    }
    onDestroy() {
        var _a, _b;
        MainHandler.log({ event: 'destroy' });
        for (const item of this.config) {
            (_b = (_a = item.handler).onDestroy) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }
    getItem({ trigger, type }) {
        let predicate;
        if (type) {
            predicate = (item) => item.trigger.name === type.name;
        }
        else {
            predicate = (item) => {
                const itemTrigger = item.trigger.trigger;
                if (isString(itemTrigger))
                    return itemTrigger === trigger;
                return itemTrigger.test(trigger);
            };
        }
        return this.config.find(predicate);
    }
}
